"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.secondsToMinSec = void 0;
const date_fns_1 = require("date-fns");
const es_1 = __importDefault(require("date-fns/locale/es"));
(0, date_fns_1.setDefaultOptions)({ locale: es_1.default });
const secondsToMinSec = (seconds) => {
    const date = (0, date_fns_1.addSeconds)(new Date(0), seconds);
    return (0, date_fns_1.format)(date, 'm:ss');
};
exports.secondsToMinSec = secondsToMinSec;
__exportStar(require("date-fns"), exports);
//# sourceMappingURL=index.js.map